import { useQuery } from 'react-query';

import listedKitService from 'resources/listedkit/listedkit.service';

const getListedKitsByDealId = async (dealId) => {
  const listedKits = await listedKitService.find({ deal_id: dealId });

  return listedKits;
};

export default function useListedKitsByDealId(dealId, queryOptions) {
  return useQuery(
    ['listedKits.getByDealId', dealId],
    () => getListedKitsByDealId(dealId),
    queryOptions,
  );
}
